<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Mon panier</h1>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xl-8">
            <div class="card cart">
              <div class="card-header">
                <h3 class="card-title">Shopping Cart</h3>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-bordered table-vcenter">
                    <thead>
                    <tr class="border-top">
                      <th>Product</th>
                      <th>Title</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Subtotal</th>
                      <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in cartItems" :key="item.id">
                      <td>
                        <div class="text-center">
                          <img :src="item.imageUrl || 'default.jpg'" alt="" class="cart-img text-center">
                        </div>
                      </td>
                      <td>{{ item.name }}</td>
                      <td class="fw-bold">${{ item.referencePrice }}</td>
                      <td>
                        <div class="handle-counter">
                          <button type="button" class="counter-minus btn btn-white lh-2 shadow-none" @click="decrementItem(item)">
                            <i class="fe fe-minus text-muted"></i>
                          </button>
                          <input type="text" :value="item.quantity" class="qty" readonly>
                          <button type="button" class="counter-plus btn btn-white lh-2 shadow-none" @click="incrementItem(item)">
                            <i class="fe fe-plus text-muted"></i>
                          </button>
                        </div>
                      </td>
                      <td>${{ item.referencePrice * item.quantity }}</td>
                      <td>
                        <div class="d-flex g-2">
                          <button class="btn text-danger bg-danger-transparent btn-icon py-1" @click="removeItem(item.id)">
                            <span class="bi bi-trash fs-16"></span>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="cartItems.length === 0">
                      <td colspan="6" class="text-center text-muted">Votre panier est vide.</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col-md-6 col-sm-6">
                    <div class="input-group mb-1">
                      <input type="text" class="form-control" placeholder="Search ...">
                      <span class="input-group-text btn btn-primary">Apply Coupon</span>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-6 text-end">
                    <a href="javascript:void(0)" class="btn btn-default disabled btn-md">Update Cart</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-xl-4 col-sm-12 col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="card-title">Cart Totals</div>
              </div>
              <div class="card-body py-2">
                <div class="table-responsive">
                  <table class="table table-borderless text-nowrap mb-0">
                    <tbody>
                    <tr>
                      <td class="text-start">Sub Total</td>
                      <td class="text-end"><span class="fw-bold  ms-auto">${{ cartTotal }}</span></td>
                    </tr>
                    <tr>
                      <td class="text-start fs-18">Total Bill</td>
                      <td class="text-end"><span class="ms-2 fw-bold fs-23">${{ cartTotal }}</span></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <div class="btn-list">
                  <router-link to="/vente/catalogue" class="btn btn-primary">
                    <i class="fe fe-arrow-left me-1"></i>Continue Shopping
                  </router-link>
                  <a href="javascript:void(0)" class="btn btn-success float-sm-end" @click="checkout">
                    Check out<i class="fe fe-arrow-right ms-1"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from "vuex";

  export default {
    name: 'ShopCart',
    computed: {
      ...mapGetters('cart', ['cartItems', 'cartTotal'])
    },
    methods: {
      ...mapMutations('cart', ['updateQuantity', 'removeItem']),
      incrementItem(item) {
        this.updateQuantity({ id: item.id, delta: 1 });
      },
      decrementItem(item) {
        if (item.quantity > 1) {
          this.updateQuantity({ id: item.id, delta: -1 });
        }
      },
      checkout() {
        this.$router.push({ name: 'shopCheckout' });
      }
    },
    mounted() {
      this.$store.dispatch('cart/loadCart');
    }
  };
</script>

<style scoped>
.page-container {
  padding: 20px;
}
</style>
